/**
 * Animazione della hero con video di `template-parts/hero/single-project-hero.php`:
 * la sezione resta pinnata mentre il titolo sale, l'immagine ancorata in basso
 * a destra si apre a tutto schermo e solo allora compare il play, che apre il
 * lightbox (gestito da `common.js` tramite `.js-video-lightbox`).
 *
 * La usano i progetti e le due sotto-pagine della Scuola di Armando: l'aggancio
 * è il contenitore `#at-project-video-container` che avvolge il template part.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initProjectHeroAnimation() {
	const container = document.querySelector('#at-project-video-container');

	if (!container) {
		return;
	}

	const title = document.querySelector('#at-project-video-text');
	const image = document.querySelector('#at-project-video-img');
	const btn = document.querySelector('#at-project-btn-play');

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: container,
			start: 'top top',
			end: 'bottom center', // se non piace rimettere "bottom center"
			scrub: 1,
			pin: true,
			//markers: true,
		},
	});

	// Animazione per il titolo
	if (title) {
		tl.to(title, {
			y: '-200%',
			duration: 1,
			ease: 'none',
		});
	}

	// Aggiungi animazione per l'immagine
	if (image) {
		tl.to(
			image,
			{
				width: '100%',
				height: '100%',
				top: 0,
				left: 0,
				duration: 1,
				ease: 'none',
			},
			'<'
		);
	}

	// Aggiungi animazione per il bottone
	if (btn) {
		tl.to(btn, {
			opacity: 1,
			visibility: 'visible',
			duration: 1,
			delay: 0.2,
			ease: 'none',
		});
	}

	// Aggiungi un po' di spazio in basso
	tl.to(container, {
		height: '20vh',
		duration: 1,
		ease: 'none',
	});
}
